/* eslint-disable no-eval */
type PageTableRequestContext<K extends keyof any, T> = {
  [P in K]: T;
}

let globalSingleMap = null;

const getGolbalSingleMap = () => {
  if(!globalSingleMap){
    globalSingleMap = new Map();
  }
  return globalSingleMap;
}

const getContextInfo = (key: string): PageTableRequestContext<string, any> => {
  const map = getGolbalSingleMap();
  if(map.has(key)){
    return map.get(key);
  }
  return {};
}

// 根据标识的key值保存当前页面request请求参数
const saveContextInfo = (key:string, params: PageTableRequestContext<string, any>) => {
  const map = getGolbalSingleMap();
  console.log(map);
  if(key && key.length> 0 ){
    map.set(key, params);
  }
}

const deleteContextInfo = (key: string):void => {
  const map = getGolbalSingleMap();
  if(map.has(key)){
    map.delete(key)
  }
}

export const usePageTableContext = () => ({
  getContextInfo,
  saveContextInfo,
  deleteContextInfo,
})